'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
        const {currentPost, postsBasePath} = useLoadPostBySlug("2025/11/abissa-chasse-tresor-grand-bassam");

    return (
        <PostContentFallback>
        <article>
            <div style={{backgroundImage: `url(${currentPost?.image})`}} className={"h-[400px] w-full bg-cover bg-center relative"}>
                <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                    <SectionPage sectionType={"2xl"}>
                        <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                    </SectionPage>
                </div>
            </div>

            <SectionPage sectionType={"xl"} className={"my-12"}>
                <div className="markdown-content text-gray-800">
                <p className="my-4 text-normal leading-relaxed">
                    Grand-Bassam a vibré au rythme de l’Abissa 2025, un événement emblématique mêlant culture, traditions et patrimoine vivant.<br/>
                    En parallèle, Côte d’Ivoire Tourisme a organisé une chasse au trésor immersive, où familles, amis et aventuriers ont exploré la ville, résolu des énigmes et découvert des surprises.
                </p>

                        <div className={'my-8'}>
                            {/* <ImageGallery images={
                                Array.from({ length: 1 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/${index + 1}.jpg`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                                }))
                            } aspectRatio={"video"} /> */}

                            <video
                                controls
                                autoPlay
                                className="w-full max-w-3xl mx-auto rounded-lg shadow-lg"
                            >
                                <source
                                    src={`/images${postsBasePath}/${String(currentPost?.slug)}/publi-reportage.mp4`}
                                    type="video/mp4"
                                />
                                Votre navigateur ne supporte pas la lecture de vidéos.
                            </video>

                            </div>
                    

                    <Tags tags={['Abissa2025', 'GrandBassam', 'CultureIvoirienne', 'Tradition', 'PatrimoineVivant', 'ChasseAuTresor', 'AventureIvoirienne', 'FamilleEtAmis', 'ExploreCI', 'Découverte', 'CôtedIvoireTourisme', 'FestivalIvoirien']} />
                </div>

                <SimilarPosts currentSlug={String(currentPost?.slug)} />
            </SectionPage>
        </article>
        </PostContentFallback>
    );
}
